module.exports = __webpack_public_path__ + "media/images/flags/64/Belgium-8cff92fa8b20dcd1dafb7a4a942d9938.png";